export default __webpack_public_path__ + "static/laptop-0a697e42b2a47c2fefacb8ce5950f8cf.png";